<template>
  <MenuCard title="Post Processing" tooltip="Apply cool post processing effects to change how your final result looks - Make sure to play with the settings and have fun with them!">
    <v-card-text class="pa-4 ma-0">
      <div>
        <Row title="Enable">
            <v-switch class="pb-2 ma-0" v-model="isPostProcessingEnabled" hide-details></v-switch>
        </Row>
        <v-menu open-on-hover offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="primary">
              Add Effect
            </v-btn>
          </template>

          <v-list style="width: 400px; max-height: 400px; overflow-y: auto;">
            <v-list-group @click.stop.prevent v-for="(group, group_index) in availableShaders" :key="group_index">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title style="font-size: 18px;">{{group.group_title}}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                <v-list-item two-line
                  v-for="(item, index) in group.group_members"
                  :key="index"
                  @click="addPostProcessingShader(item)"
                >
                  <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
            </v-list-group>
          </v-list>
        </v-menu>
        <v-divider class="my-2"></v-divider>

        <div 
        @dragover="onDragOver"
        @dragenter="onDragEnter"
        @dragleave="onDragLeave"
              :class="{ dropzone: isShowDropZone }" @drop='onDrop($event, 0)'>
        </div>
        <v-list class="pa-0 ma-0">
          <v-list-item
            class="pa-0 ma-0"
            style="display: block;"
            v-for="(item, index) in postProcessingShaders"
            draggable=true
            @dragstart='startDrag($event, index)' 
            @dragend='endDrag'
            :key="index"
          >
            <shader-card draggable @dragend='endDrag' @dragstart='startDrag($event, index)' :shader="item">
            </shader-card>

            <div 
            @dragover="onDragOver"
            @dragenter="onDragEnter"
            @dragleave="onDragLeave"
            :class="{ dropzone: isShowDropZone }" @drop='onDrop($event, index + 1)'>
            </div>
          </v-list-item>
        </v-list>
        </div>
    </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue'
import Vuex from 'vuex';
import ShaderCard from './ShaderCard';
import { AvailableShaders } from '../shaders/AvailableShaders.js'
import Row from './Row.vue'
//import { Color } from 'three';

  export default {
    name: 'PostProcessingMenu',
    components: {
        MenuCard,
        ShaderCard,
        Row,
    },
    methods: {
        addPostProcessingShader(shader) {
            //hack to deepcopy the uniforms
            //let newShader = JSON.parse(JSON.stringify(shader));

            //create a shallow copy
            //console.log("Adding shader:", shader);
            let newShader = {...shader};
            newShader.uniforms = { ...shader.uniforms};
            newShader.properties = { isEnabled: true };

            for (var uniform in newShader.uniforms) {
                //console.log(uniform, newShader.uniforms[uniform].value);
                newShader.uniforms[uniform] = {...shader.uniforms[uniform]};
                let value = newShader.uniforms[uniform].value;
                //console.log(value.constructor.name);
                if (value.constructor.name == 'Color') {
                    newShader.uniforms[uniform].value = value.clone();
                }
                if (value.constructor.name == 'Vector2') {
                    newShader.uniforms[uniform].value = value.clone();
                }
            }

            this.$store.commit('addPostProcessingShader', newShader);
        },
        startDrag(e, index) {
            this.isStoppedDragging = false;
            setTimeout(() => {
                if (!this.isStoppedDragging) {
                    this.isShowDropZone = true;
                }
            }, 100);
            //console.log("start drag!", index);
            //e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('index', index);
        },
        endDrag() {
            this.isStoppedDragging = true;
            this.isShowDropZone = false;
        },
        onDrop(e, indexToMoveTo) {
            e.target.style.backgroundColor = '#3f80e880';
            this.isStoppedDragging = true;
            this.isShowDropZone = false;
            e.preventDefault();
            e.stopPropagation();

            var fromIndex = e.dataTransfer.getData("index");
            var toIndex = indexToMoveTo;

            //console.log("on drop! Trying to move index: " + fromIndex + " to: " + toIndex);
            if (fromIndex == toIndex) {
                //console.log("The same index, not moving");
                return false;
            }
            if (fromIndex + 1 == toIndex) {
                //console.log("The same index + 1, not moving");
                return false;
            }
            //console.log("Should move");
            this.$store.commit("changeShadersOrder", {fromIndex, toIndex});
            //console.log(e);
            //console.log("Got Index:", e.dataTransfer.getData("index"));
            //e.dataTransfer.dropEffect = 'move';
            //e.dataTransfer.effectAllowed = 'move';
            //e.dataTransfer.setData('index', index);
        },
        onDragOver(e) {
            e.target.style.backgroundColor = '#3f80e8ff';
            e.dataTransfer.dropEffect = 'move';
            e.preventDefault();
            e.stopPropagation();
            //console.log("Drag Over!");
        },
        onDragEnter(e) {
            e.target.style.backgroundColor = '#3f80e8ff';
            e.dataTransfer.dropEffect = 'move';
            e.preventDefault();
            e.stopPropagation();
            //console.log("Drag Enter!");
        },
        onDragLeave(e) {
            e.target.style.backgroundColor = '#3f80e880';
            e.dataTransfer.dropEffect = 'move';
            e.preventDefault();
            e.stopPropagation();
            //console.log("Drag Over!");
        },
    },
    
    mounted() {
    },

    data: function () {
        //console.log(AvailableShaders);
        return { 
                //availableShaders: [ {title: 'Pixel Shader'}, 
                //          {title: 'click me!'}, 
                //          {title: 'noice!'}],
                isShowDropZone: false,
                availableShaders: AvailableShaders,
               };
    },

    props: [],
    watch: {
    },

    computed: {
        ...Vuex.mapState([
                'postProcessingShaders',
                '',
        ]),
        isPostProcessingEnabled: {
            get() {
                return this.$store.state.isPostProcessingEnabled;
            },
            set(value) {
                this.$store.commit('setIsPostProcessingEnabled', value);
            },
        },
    },

  }
</script>
<style>
.dropzone {
    padding: 8px;
    background-color: #3f80e880;
    /* background-color: rgba(90, 72, 255, 0.4); */
    transition: padding 0.6s;
    border-radius: 25px;
}
</style>

